import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Board } from "./scenes";
import { Provider } from "react-redux";
import appStore from "./utils/appStore";
import Home from "./scenes/home/Home";
import Login from "./scenes/auth/login/Login";
import Register from "./scenes/auth/register/Register";
import { ReactFlowProvider } from "@xyflow/react";
import { Toaster } from "react-hot-toast";
import VerifyEmail from "./scenes/auth/verifyEmail/VerifyEmail";
import Dashboard from "./scenes/dashboard/Dashboard";
import VerifyEmailForPassword from "./scenes/auth/verifyEmailForPassword/VerifyEmailForPassword";
import UpdatePassword from "./scenes/auth/updatePassword/UpdatePassword";
import Subscription from "./scenes/subscription/Subscription";
import Administrator from "./scenes/administrator/Administrator";
import PrivateRoute from "./PrivateRout";

function App() {
  return (
    <div className="min-w-screen max-w-screen">
      <Provider store={appStore}>
        <BrowserRouter>
          <Routes>
            <Route index element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verifyEmail" element={<VerifyEmail />} />
            <Route
              path="/verifyEmailForPassword"
              element={<VerifyEmailForPassword />}
            />
            <Route path="/updatePassword" element={<UpdatePassword />} />
            <Route
              path="/boards"
              element={
                <PrivateRoute>
                  <ReactFlowProvider>
                    <Board />
                  </ReactFlowProvider>
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            {/* <Route path="/subscription" element={<Subscription />} /> */}
            <Route
              path="/administrator"
              element={
                <PrivateRoute>
                  <Administrator />
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Provider>
      <Toaster />
    </div>
  );
}

export default App;
